// extracted by mini-css-extract-plugin
export default {"rating":"oF-z","numberOfStars":"pF-z","count":"qF-z","barGraphSpacing":"rF-z","barGraph":"sF-z"};